<template>

  <div
    class="row"
    :class="{'box-loading': loading}">
    <div class="col-sm">
      <ul
        class="list-group"
        v-sortable="{ items: job.stages}">
        <li
          class="list-group-item move"
          v-for="(item, index) in job.stages"
          :key="index"
          :class="{'sortable-disabled': item.fixed}">

          <div class="d-flex">
            <div
              v-if="!item.fixed"
              class="mr-2">
              <i class="fas fa-arrows-alt" />
            </div>
            <div class="w-100">{{ item.name }}</div>
            <div
              v-if="!item.fixed"
              class="ml-2">
              <a
                href="javascript:void(0)"
                @click="removeStage(index)">{{ $t('Remove') }}</a>
            </div>
          </div>
          
        </li>
      </ul>
    </div>
    <div class="col-sm">
      <ul class="list-group">
        <li
          class="list-group-item"
          v-for="(item, index) in notSelected"
          :key="index">

          <div class="d-flex">
            <div class="w-100">{{ item.name }}</div>
            <div
              v-if="!item.fixed"
              class="ml-2">
              <a
                href="javascript:void(0)"
                @click="addStage(index)">{{ $t('Add') }}</a>
            </div>
          </div>
          
        </li>
      </ul>
    </div>
  </div>

</template>


<script>
export default {
  name: 'JobFormStages',
  components: {
  },
  props: [
    'initJob',
    'validateErrors'
  ],
  data () {
    return {
      loading: false,
      job: this.$clone(this.initJob),
      stages: []
    }
  },
  computed: {
    notSelected () {
      return this.stages.filter((stage) => {
        return !this.job.stages.find(v => v._id === stage._id)
      })
    }
  },
  watch: {
    job: {
      handler: function (newValue) {
        const {
          stages
        } = newValue
        this.$emit('changed', {
          stages
        })
      },
      deep: true
    }
  },
  created () {
    this.loadStages()
  },
  methods: {
    loadStages () {
      this.loading = true

      this.$store
      .dispatch('getStages', {
        limit: 100
      })
      .then((result) => {
        this.loading = false
        this.stages = result
      })
    },
    addStage (index) {
      const item = this.notSelected[index]

      const afterIndex = this.job.stages.map(stage => {
        return this.stages.find(v => v._id === stage._id)
      }).findIndex(stage => {
        return stage && stage.position >= item.position
      })

      const newIndex = afterIndex >= 0 ? afterIndex : this.job.stages.length

      this.job.stages.splice(newIndex, 0, item)
    },
    removeStage (index) {
      this.job.stages.splice(index, 1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.move{
  cursor: move;
}
</style>



// WEBPACK FOOTER //
// src/components/JobForm/JobFormStages.vue